// removed by extract-text-webpack-plugin
module.exports = {"AppointmentCard":"AppointmentCard__AppointmentCard___12_px","CardStatus":"AppointmentCard__CardStatus___3ISi-","CardContent":"AppointmentCard__CardContent___3SWVj","AppointmentInfo":"AppointmentCard__AppointmentInfo___yQ-la","BuildingName":"AppointmentCard__BuildingName___3OciZ","Data":"AppointmentCard__Data___oxlZw","ShowAppointmentButton":"AppointmentCard__ShowAppointmentButton___257gR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Appointments/AppointmentCard/AppointmentCard.scss
// module id = 1442
// module chunks = 0